export const gsStyle = (theme) => {
  return `.ant-picker-header-view button{
    font-family: ${theme.palette.fontFamily} !important;
    font-size: 16px !important;
    color: ${theme.colors.PRIMARY_CONTRAST} !important;
  }
  .ant-picker-panel-container, .ant-picker-range-arrow::before{
    background-color: ${theme.colors.PRIMARY_MAIN} !important;
    border: 1px solid ${theme.colors.INPUT_BORDER} !important;
    border-radius: 5px !important;
  }
  .ant-picker-content th, .ant-picker-cell-inner, .ant-picker-prev-icon::before, .ant-picker-next-icon::before, .ant-picker-super-prev-icon::before, .ant-picker-super-next-icon::before, .ant-picker-super-prev-icon::after, .ant-picker-super-next-icon::after{
      color: ${theme.colors.PRIMARY_CONTRAST} !important;
  }
  .ant-picker-cell-in-view.ant-picker-cell-selected .ant-picker-cell-inner, .ant-picker-cell-in-view.ant-picker-cell-range-start .ant-picker-cell-inner, .ant-picker-cell-in-view.ant-picker-cell-range-end .ant-picker-cell-inner {
    color: #fff !important;
    background: ${theme.colors.SECONDARY_MAIN} !important;
  }
  .ant-picker-cell-in-view.ant-picker-cell-in-range::before, .ant-picker-cell-in-view.ant-picker-cell-range-start:not(.ant-picker-cell-range-start-single)::before, .ant-picker-cell-in-view.ant-picker-cell-range-end:not(.ant-picker-cell-range-end-single)::before {
    background: ${theme.colors.RANGE_PICKER?.CELL_BG} !important;
}

  .ant-picker-cell-in-view.ant-picker-cell-in-range.ant-picker-cell-range-hover::before,
  .ant-picker-cell-in-view.ant-picker-cell-range-start.ant-picker-cell-range-hover::before,
  .ant-picker-cell-in-view.ant-picker-cell-range-end.ant-picker-cell-range-hover::before,
  .ant-picker-cell-in-view.ant-picker-cell-range-start:not(.ant-picker-cell-range-start-single).ant-picker-cell-range-hover-start::before,
  .ant-picker-cell-in-view.ant-picker-cell-range-end:not(.ant-picker-cell-range-end-single).ant-picker-cell-range-hover-end::before,
  .ant-picker-panel > :not(.ant-picker-date-panel) .ant-picker-cell-in-view.ant-picker-cell-in-range.ant-picker-cell-range-hover-start::before,
  .ant-picker-panel > :not(.ant-picker-date-panel) .ant-picker-cell-in-view.ant-picker-cell-in-range.ant-picker-cell-range-hover-end::before ,
  .ant-picker-date-panel .ant-picker-cell-in-view.ant-picker-cell-in-range.ant-picker-cell-range-hover-start .ant-picker-cell-inner::after,
  .ant-picker-date-panel .ant-picker-cell-in-view.ant-picker-cell-in-range.ant-picker-cell-range-hover-end .ant-picker-cell-inner::after {
    background: ${theme.colors.RANGE_PICKER?.CELL_HOVER_BG} !important;
  }
  .ant-picker-cell-in-view.ant-picker-cell-today .ant-picker-cell-inner::before {
    border: 1px solid ${theme.colors.SECONDARY_MAIN} !important;
  }
  .ant-picker-cell:hover:not(.ant-picker-cell-in-view) .ant-picker-cell-inner, .ant-picker-cell:hover:not(.ant-picker-cell-selected):not(.ant-picker-cell-range-start):not(.ant-picker-cell-range-end):not(.ant-picker-cell-range-hover-start):not(.ant-picker-cell-range-hover-end) .ant-picker-cell-inner {
      color: ${theme.colors.PRIMARY_CONTRAST} !important;
  }
  tr > .ant-picker-cell-in-view.ant-picker-cell-range-hover:first-child::after,
  tr > .ant-picker-cell-in-view.ant-picker-cell-range-hover-end:first-child::after,
  .ant-picker-cell-in-view.ant-picker-cell-start.ant-picker-cell-range-hover-edge-start.ant-picker-cell-range-hover-edge-start-near-range::after,
  .ant-picker-cell-in-view.ant-picker-cell-range-hover-edge-start:not(.ant-picker-cell-range-hover-edge-start-near-range)::after,
  .ant-picker-cell-in-view.ant-picker-cell-range-hover-start::after {
    border-left: 1px dashed ${theme.colors.SECONDARY_MAIN} !important;
  }
  tr > .ant-picker-cell-in-view.ant-picker-cell-range-hover:last-child::after,
  tr > .ant-picker-cell-in-view.ant-picker-cell-range-hover-start:last-child::after,
  .ant-picker-cell-in-view.ant-picker-cell-end.ant-picker-cell-range-hover-edge-end.ant-picker-cell-range-hover-edge-end-near-range::after,
  .ant-picker-cell-in-view.ant-picker-cell-range-hover-edge-end:not(.ant-picker-cell-range-hover-edge-end-near-range)::after,
  .ant-picker-cell-in-view.ant-picker-cell-range-hover-end::after {
    border-right: 1px dashed ${theme.colors.SECONDARY_MAIN} !important;

  }
  .ant-picker-cell-in-view.ant-picker-cell-range-hover-start:not(.ant-picker-cell-in-range):not(.ant-picker-cell-range-start):not(.ant-picker-cell-range-end)::after,
  .ant-picker-cell-in-view.ant-picker-cell-range-hover-end:not(.ant-picker-cell-in-range):not(.ant-picker-cell-range-start):not(.ant-picker-cell-range-end)::after,
  .ant-picker-cell-in-view.ant-picker-cell-range-hover-start.ant-picker-cell-range-start-single::after,
  .ant-picker-cell-in-view.ant-picker-cell-range-hover-start.ant-picker-cell-range-start.ant-picker-cell-range-end.ant-picker-cell-range-end-near-hover::after,
  .ant-picker-cell-in-view.ant-picker-cell-range-hover-end.ant-picker-cell-range-start.ant-picker-cell-range-end.ant-picker-cell-range-start-near-hover::after,
  .ant-picker-cell-in-view.ant-picker-cell-range-hover-end.ant-picker-cell-range-end-single::after,
  .ant-picker-cell-in-view.ant-picker-cell-range-hover:not(.ant-picker-cell-in-range)::after {

    border-top: 1px dashed ${theme.colors.SECONDARY_MAIN} !important;
    border-bottom: 1px dashed ${theme.colors.SECONDARY_MAIN} !important;
  }
  .ant-picker-range-arrow{
      display: none !important;
  }
  .ant-picker-ranges .ant-picker-preset > .ant-tag-blue {
    color: ${theme.colors.PRIMARY_CONTRAST} !important;
    background: ${theme.colors.PRIMARY_MAIN} !important;
    border-color: ${theme.colors.PRIMARY_CONTRAST} !important;
  }
  .ant-picker-header-view button:hover {
    color: ${theme.colors.SECONDARY_MAIN} !important;
}
.ant-picker-panel-container .ant-picker-panel{
  border-right: 1px solid ${theme.colors.INPUT_BORDER} !important;
  border-bottom: none;
}
.ant-picker-header {
  border-bottom: 1px solid ${theme.colors.INPUT_BORDER} !important;
}
.ant-color-picker-trigger, .ant-popover-arrow:after, .ant-popover-arrow:before , .ant-popover-inner {
  background: ${theme.colors.PRIMARY_MAIN} !important;
}
.ant-color-picker {
  .ant-select-selection-item {
    color: ${theme.colors.PRIMARY_CONTRAST} !important;
  }
  .ant-popover-inner{
    border: ${theme.colors.PRIMARY_BORDER} 1px solid !important;
  }
}`
}
